export default {
  recordTitle: '提現記錄',
  empty: '該篩選下暫無提現記錄',
  filterType: '提現類型',
  filterStatus: '提現狀態',
  st: {
    all: '全部',
    ok: '已到賬',
    pend: '處理中',
    rej: '已駁回',
    cancel: '已撤銷',
  },
  detailAccount: '到賬賬戶',
  cancel: '撤銷提現(原路退回)',
  cancelling: '正在撤銷…',
  cancelOk: '已撤銷,資金已原路退回',
  resubmit: '重新提交',
  resubmitToast: '已帶入原信息,請核對收款賬戶後重新提交',
  cryptoPending: '審核中,通過後鏈上廣播',
}
